module.exports = __webpack_public_path__ + "0b4bb717cb2c23a26ca8ba244a1a171a.jpg";